module.exports = __webpack_public_path__ + "static/media/nenglifen1.2cb23df7.jpg";